<div [ngClass]="{'notified-confirmation-modal': config.data.headerNotificationType === 'high-severity-primary'}">
  <div id="modal-header-notification">
    <wfm-system-notification
      class="u-mb----"
      type="{{ config.data.headerNotificationType }}"
      headingText="{{ config.data.headerNotificationText | translate }}"
      [multiLineLayout]="true"
      [hideHeaderUtility]="true"
      [hideCloseButton]="true"
    >
    </wfm-system-notification>
  </div>

  <div class="modal__content u-mt--">
    <div *ngIf="!isProcessing">
      {{ config.data.message }}
    </div>
    <ng-container *ngIf="isProcessing">
      <div class="flex flex--row flex--center">
        <wfm-spinner [show]="true" [size]="22"></wfm-spinner>
      </div>
    </ng-container>
  </div>

  <div class="flex flex--row u-p" style="justify-content: right;">
    <button id="update-no-button"
            class="button button--tertiary"
            (click)="onClose(false); $event.stopPropagation()"
            tabindex="2"
            [disabled]="isProcessing"
            [innerHTML]="config.data.noButtonLabel">
    </button>
    <button id="update-yes-button"
            class="button button--primary u-ml- u-mr0"
            (click)="onClose(true); $event.stopPropagation()"
            [disabled]="isProcessing"
            tabindex="1"
            [innerHTML]="config.data.yesButtonLabel">
    </button>
  </div>
</div>
